import React from 'react';
import Icon from '../AppIcon';

/**
 * StatsCard - Reusable KPI card component
 * Extracted from Construction Budget page for pixel-level visual consistency.
 *
 * Props:
 *   title       {string}  - Label shown above the value
 *   value       {string|number} - The main display value
 *   iconName    {string}  - Lucide icon name
 *   iconColor   {string}  - Tailwind text color class for the icon (e.g. 'text-blue-500')
 *   valueColor  {string}  - Tailwind text color class for the value (e.g. 'text-blue-500')
 *   titleWeight {string}  - Optional: 'font-medium' (default) or 'font-semibold'
 *   sublabel    {string}  - Optional: small note shown below the value
 */
const StatsCard = ({
  title,
  value,
  iconName,
  iconColor = 'text-gray-400',
  valueColor = 'text-gray-900',
  titleWeight = 'font-medium',
  sublabel,
}) => {
  return (
    <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm min-w-[120px]">
      <div className="flex items-center justify-between mb-1">
        <p className={`text-[10px] text-gray-500 ${titleWeight}`}>{title}</p>
        <Icon name={iconName} size={12} className={iconColor} />
      </div>
      <p className={`text-sm font-semibold ${valueColor}`}>
        {value}
      </p>
      {sublabel && (
        <p className="text-[9px] text-gray-400 mt-0.5 leading-tight">{sublabel}</p>
      )}
    </div>
  );
};

export default StatsCard;
